export enum HMSPollUpdateType {
  started,
  resultsUpdated,
  stopped,
}
